import { useEffect } from 'react';
import { navigate } from "@reach/router"

const PortableToiletsPage = () => {
  useEffect(() => {
    navigate('/solutions/industries/portable-toilets/');
  }, []);
  return null;
};

export default PortableToiletsPage;